import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthFacade, SharedFacade } from '@piqet-angular/data';
import { emailRegex } from '@piqet-angular/shared';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'piqet-angular-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm!: FormGroup;
  submitted = false;
  typeSelected = 'line-spin-clockwise-fade';
  constructor(
    private formBuilder: FormBuilder,
    public authFacade: AuthFacade,
    public sharedFacade: SharedFacade,
    private spinnerService: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.authFacade.clearError();
    const reg = emailRegex;
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(reg)]],
    });
  }

  submit() {
    this.submitted = true;
    if (!this.forgotPasswordForm.valid) {
      this.submitted = false;
      return;
    }

    const data = {
      Email: this.forgotPasswordForm.controls['email'].value,
      URL: encodeURIComponent(
        location.origin +
          `/#/reset-password?mail=${btoa(this.forgotPasswordForm.controls['email'].value)}`
      ),
    };

    this.authFacade.forgotPassword(data);
  }
}
